import {Entity} from './base/entity';

export class WebMethodResult extends Entity {
  public static readonly WARNING = -1;
  public static readonly SUCCESS = 0;
  public static readonly ERROR = 1;
  public static readonly CARD_NOT_FOUND = 2;
  public static readonly SAVE_CHECKIN_ERROR = 3;
  public static readonly SAVE_SESSION_ERROR = 4;

  code: number;
  description: string;
  status: Status;
  timestamp: Date;
  methodResult: any;

  codetype: number;
  descriptiontype: string;
  name: Type;
  timestamptype: Date;

  public static create(code: number, desc: string) {
    const wmr = new WebMethodResult(null);
    wmr.code = code;
    wmr.description = desc;
    wmr.timestamp = new Date();
    wmr.status = code === -1 ? Status.WARNING : code === 0 ? Status.SUCCESS : Status.ERROR;

    return wmr;
  }

  public static create1(code1: number, desc: string) {
    const wmr = new WebMethodResult(null);
    wmr.codetype = code1;
    wmr.descriptiontype = desc;
    wmr.timestamp = new Date();
    wmr.name = code1 === -1 ? Type.WARNING : code1 === 0 ? Type.SUCCESS : Type.ERROR;

    return wmr;
  }

  public get isSuccess() {
    return this.code === Status.SUCCESS;
  }

  public get isError() {
    return this.code === Status.ERROR;
  }

  public get isWarning() {
    return this.code === Status.WARNING;
  }
}

export enum Status {
  SUCCESS,
  WARNING,
  ERROR
}

export enum Type {
  SUCCESS,
  WARNING,
  ERROR
}
